import type { Me, RoleNames } from "@getaways/extranet-ui";
import { createContext, useContext } from "react";

/** Mirrors reportsAccess in @getaways/reports: what each role may see, so pages hide what it cannot use. */
const PERMISSIONS: Record<string, string[]> = {
  admin: ["reports:read", "money:read", "finance:read", "sales:all", "sync:manage", "alerts:manage", "users:manage"],
  management: ["reports:read", "money:read", "finance:read", "sales:all", "alerts:manage"],
  finance: ["reports:read", "money:read", "finance:read", "sales:all", "alerts:manage"],
  contracting: ["reports:read", "money:read", "sales:all"],
  operations: ["reports:read", "sales:all"],
  supervisor: ["reports:read", "sales:team"],
  agent: ["reports:read"],
};

export type Permission = "reports:read" | "money:read" | "finance:read" | "sales:all" | "sales:team" | "sync:manage" | "alerts:manage" | "users:manage";

export const ROLE_NAMES: RoleNames = { admin: "Administrator", management: "Management", finance: "Finance", contracting: "Contracting and product", operations: "Operations", supervisor: "Supervisor", agent: "Agent" };

export const rolesFor = () => Object.keys(PERMISSIONS);

export const canWith = (me: Me, permission: Permission) => me.user.memberships.some((m) => PERMISSIONS[m.role]?.includes(permission));

export const MeContext = createContext<Me | undefined>(undefined);

/** Whether the signed-in person may see this; the API checks again on every request. */
export function useCan(): (permission: Permission) => boolean {
  const me = useContext(MeContext);
  return (permission) => (me ? canWith(me, permission) : false);
}
